import { render, staticRenderFns } from "./NewsElement.vue?vue&type=template&id=72b3a4ae&scoped=true"
import script from "./NewsElement.vue?vue&type=script&lang=js"
export * from "./NewsElement.vue?vue&type=script&lang=js"
import style0 from "./NewsElement.vue?vue&type=style&index=0&id=72b3a4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b3a4ae",
  null
  
)

export default component.exports